// extracted by mini-css-extract-plugin
export default {"container":"CG-z","disabled":"DG-z","termsCheckbox":"EG-z","signUpButton":"FG-z","enrollingSpinner":"GG-z","learnMoreButton":"HG-z","buttonRow":"IG-z"};